module.exports = __webpack_public_path__ + "img/IQD.351d461e.svg";